import angular from 'angular';
import kendo from '@progress/kendo-ui';
import $ from 'jquery';

angular.module('webTools').directive('tooltip', ['$document', '$compile', '$timeout',
    function($document, $compile, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attributes) {

                var timer;
                var tooltipElement = '';

                element.bind('mouseover', function() {

                    tooltipElement = $compile('<div class="popover hidden">' +
                                                '<div class="popover-arrow"></div>' +
                                                '<div class="popover-content">' +
                                                    attributes.tooltip +
                                                '</div>' +
                                                '</div>')(scope);

                    $document.find('body').append(tooltipElement);

                    var position = element.offset();
                    var w = element.outerWidth();
                    var h = element.outerHeight();

                    var el = tooltipElement;

                    el.css({ 'left': position.left + ((w / 2) - (el.outerWidth() / 2)), 'top': position.top + h });

                    var effect = kendo.fx(el).fadeIn().duration(700);

                    timer = $timeout(function() { effect.play() }, 500);
                });

                element.bind('mouseout', function() {
                    tooltipElement.remove();
                });

                element.bind('click', function() {
                    tooltipElement.remove();
                });

                scope.$on('$destroy',
                    function(event) {
                        $timeout.cancel(timer);
                    }
                );
            }
        }
    }
]);

angular.module('webTools').directive('reportTooltip', ['$document', '$compile', '$timeout',
    function($document, $compile, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attributes) {

                var timer;
                var tooltipElement = '';

                element.bind('mouseover', function() {

                    tooltipElement = $compile('<div class="report-popover hidden">' +
                                                '<div class="report-popover-arrow"></div>' +
                                                '<div class="report-popover-content">' +
                                                    attributes.reportTooltip +
                                                '</div>' +
                                              '</div>')(scope);

                    $document.find('body').append(tooltipElement);

                    var position = element.offset();
                    var w = element.outerWidth();
                    var h = element.outerHeight();

                    var el = tooltipElement;

                    el.css({ 'left': position.left + w, 'top': position.top + (h / 2) - (el.height() / 2) });
                    $('.report-popover-arrow').css('top', (el.height() / 2) - 7);

                    var effect = kendo.fx(el).fadeIn().duration(700);

                    timer = $timeout(function() { effect.play() }, 500);
                });

                element.bind('mouseout', function() {
                    tooltipElement.remove();
                });

                scope.$on('$destroy',
                    function(event) {
                        $timeout.cancel(timer);
                    }
                );
            }
        }
    }
]);